export default __webpack_public_path__ + "static/profile-pic-6849d56bf39d2d15cca64432738ca155.jpg";